import { PureComponent } from 'react';

import { isNullable } from '@ipfabric/utils';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { DragSource } from 'react-dnd';
import handleEvent from 'utils/handleEvent';

const tableRowSource = {
  beginDrag(props) {
    return {
      report: props.report,
    };
  },
  canDrag(props) {
    const { report, selectedGroup, reportsGroups } = props;
    if (isNullable(selectedGroup)) {
      return true;
    }
    const foundGroup = reportsGroups.find((g) => g.id === selectedGroup);
    if (foundGroup) {
      const reportId = report.id;
      const foundReport = foundGroup.children.find((r) => r.id === reportId);
      if (foundReport) {
        return false;
      }
    }
    return true;
  },
};

function dragCollect(connect, monitor) {
  return {
    connectDragSource: connect.dragSource(),
    isDragging: monitor.isDragging(),
    canDrag: monitor.canDrag(),
  };
}

@DragSource('treeViewReport', tableRowSource, dragCollect)
export default class FoundReportItem extends PureComponent {
  static propTypes = {
    canDrag: PropTypes.bool.isRequired,
    connectDragSource: PropTypes.func.isRequired,
    onSelectReport: PropTypes.func.isRequired,
    onSelectReportAddToGroup: PropTypes.func.isRequired,
    report: PropTypes.object,
    selected: PropTypes.bool.isRequired,
    path: PropTypes.string.isRequired,
  };

  handleClick = handleEvent(() => {
    const { onSelectReport, report, canDrag } = this.props;
    if (canDrag) {
      onSelectReport(report.id);
    }
  });

  handleDoubleClick = handleEvent(() => {
    const { onSelectReportAddToGroup, report, canDrag } = this.props;
    if (canDrag) {
      onSelectReportAddToGroup(report.id);
    }
  });

  render() {
    const { canDrag, connectDragSource, report, selected, path } = this.props;
    return connectDragSource(
      <div onClick={this.handleClick} onDoubleClick={this.handleDoubleClick}>
        <div
          className={classNames(
            'dashboard-color-form__tree-view-found-report-item',
            canDrag &&
              'dashboard-color-form__tree-view-found-report-item--drag',
            selected &&
              'dashboard-color-form__tree-view-found-report-item--selected',
          )}
        >
          <span>
            <i
              className='fa-regular fa-file-lines mr-2'
              data-reportid={report.id}
            />
            {report.name}
          </span>
          <span className='dashboard-color-form__tree-view-found-report-item-path'>
            (
            <span
              className={classNames(
                'dashboard-color-form__tree-view-found-report-item-path-text',
                selected &&
                  'dashboard-color-form__tree-view-found-report-item-path-text--selected',
              )}
            >
              {path}
            </span>
            )
          </span>
        </div>
      </div>,
    );
  }
}
